import { render, staticRenderFns } from "./_Gestao_EvolucaoProjetosStatus.vue?vue&type=template&id=3d465a07&"
import script from "./_Gestao_EvolucaoProjetosStatus.vue?vue&type=script&lang=js&"
export * from "./_Gestao_EvolucaoProjetosStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports